<ng-container *ngIf="!isLayoutLoading(); else loading">
  <app-header></app-header>
  <app-mobile-sidebar #mobileSidebar></app-mobile-sidebar>
  <div class="layout">
    <app-sidebar></app-sidebar>
    <main class="content">
      <router-outlet></router-outlet>
    </main>
  </div>
</ng-container>

<ng-template #loading>
  <div class="main-layout__spinner">
    <app-spinner></app-spinner>
  </div>
</ng-template>
